<template>
  <div id="sidebar" class="sidebar">
    <div class="brand">
      <img src="../assets/images/logo_branca_bi.png" alt="Logo" class="brand-logo">
    </div>

    <button class="cmdk-trigger" @click="abrirBusca">
      <i class="bi bi-search"></i>
      <span>{{$t('buscar_relatorio')}}</span>
      <kbd>Ctrl K</kbd>
    </button>

    <nav class="nav-scroll">
      <div class="glist" style="margin-bottom: 14px;">
        <div class="row" :class="{ on: abaAtiva === this.$t('inicio') }" @click="paginaInicial()">
          <i class="bi bi-house-door"></i>
          <span style="width: 40px;">{{ $t('inicio')}}</span>
        </div>
      </div>

      <div class="grupo" v-for="(menu, index) in getMenus" :key="index">
        <button class="glabel" @click="alternarGrupo(index)">
          <span>{{ menu.ds_nome }}</span>
          <i class="bi" :class="grupoAberto(index) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
        </button>

        <div class="glist" v-show="grupoAberto(index)">
          <div
            class="row"
            v-for="(link, i) in menu.links"
            :key="i"
            :class="{ on: abaAtiva === link.lk_link }"
            :title="link.ds_link"
            @click="abrirRelatorio(link)"
            @mouseenter="mostrarHorario($event, link)"
            @mouseleave="ocultarHorario"
          >
            <i :class="'bi ' + link.ic_link"></i>
            <span class="row-texto">{{ link.ds_link }}</span>
          </div>
        </div>
      </div>
    </nav>

    <div class="foot">
      <div class="userrow" @click="menuAberto = !menuAberto">
        <div class="avatar"><i class="bi bi-person"></i></div>
        <div class="g">
          <span>{{ nomeEmpresa }}</span>
          <small>{{$t('acesso_power_bi')}}</small>
        </div>
        <i class="bi bi-three-dots-vertical"></i>
      </div>

      <div class="foot-menu" v-if="menuAberto">
        <a class="foot-menu-item" href="https://inove.tomticket.com" target="_blank">
          <i class="bi bi-life-preserver"></i> {{$t('ajuda')}}
        </a>
        <a class="foot-menu-item" @click="logout()">
          <i class="bi bi-box-arrow-left"></i> {{$t('sair')}}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      gruposAbertos: { 0: true },
      menuAberto: false
    }
  },
  computed: {
    getMenus() {
      return this.$store.getters['busca/getMenus']
    },
    abaAtiva() {
      return this.$store.getters['abas/abaAtiva']
    },
    nomeEmpresa() {
      const nomeEmpresaJson = this.$store.getters['busca/filial']
      let nome_empresa = nomeEmpresaJson.empresa

      return nome_empresa
    }
  },
  methods: {
    grupoAberto(index) {
      return !!this.gruposAbertos[index]
    },
    alternarGrupo(index) {
      this.gruposAbertos = { ...this.gruposAbertos, [index]: !this.gruposAbertos[index] }
    },
    logout() {
      this.$store.dispatch('busca/logout')
    },
    abrirBusca() {
      this.$store.dispatch('ui/abrirComando')
    },
    abrirRelatorio(link) {
      this.$store.dispatch('abas/abrirRelatorio', link)
      this.fechaSidebar()
    },
    mostrarHorario(evento, link) {
      if (!link.horario || !link.horario.length) return

      const rect = evento.currentTarget.getBoundingClientRect()

      this.$store.dispatch('ui/mostrarTooltipHorario', {
        top: rect.top,
        left: rect.right + 8,
        horarios: link.horario
      })
    },
    ocultarHorario() {
      this.$store.dispatch('ui/ocultarTooltipHorario')
    },
    paginaInicial() {
      this.$store.dispatch('abas/ativarAba', 'inicio')
      this.fechaSidebar()
    },
    fechaSidebar() {
      if (window.innerWidth >= 720) return

      const btnSidebar = document.querySelector('.btn-toggle-sidebar')
      if (btnSidebar && !btnSidebar.classList.contains('fechada')) {
        btnSidebar.click()
      }
    }
  },
  created() {
    this.$store.dispatch('busca/getMenus')
  },
  beforeDestroy() {
    this.ocultarHorario()
  }
}
</script>

<style scoped>
.sidebar {
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: var(--rd-radius-lg);
  height: calc(100vh - 20px);
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 14px 10px;
}

.brand {
  display: flex;
  align-items: center;
  padding: 4px 6px 12px;
}

.brand-logo {    
  max-height: 50px;
  margin: -7px;
}

.cmdk-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius-sm);
  padding: 8px 10px;
  margin-bottom: 14px;
  color: var(--rd-text-3);
  cursor: pointer;
  width: 100%;
}

.cmdk-trigger:hover {
  border-color: var(--rd-border-strong);
  color: var(--rd-text-2);
}

.cmdk-trigger span {
  flex: 1;
  text-align: left;
  font-size: 12px;
}

.cmdk-trigger kbd {
  font-size: 10px;
  border: 1px solid var(--rd-border-strong);
  border-radius: 5px;
  padding: 1px 6px;
  color: var(--rd-text-3);
}

.nav-scroll {
  flex: 1;
  overflow-y: auto;
}

.grupo {
  margin-bottom: 6px;
}

.glabel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  border: none;
  color: var(--rd-text-3);
  font-size: 10.5px;
  letter-spacing: 0.06em;
  padding: 10px 8px 6px;
  cursor: pointer;
}

.glist {
  border-radius: var(--rd-radius-md);
  overflow: hidden;
  border: 1px solid var(--rd-border);
}

.row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 10px;
  color: var(--rd-text-2);
  border-bottom: 1px solid var(--rd-border);
  cursor: pointer;
  font-size: 12.5px;
}

.glist .row:last-child {
  border-bottom: none;
}

.row i {
  font-size: 15px;
  width: 16px;
  text-align: center;
  color: var(--rd-text-3);
}

.row:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.row.on {
  background: var(--rd-hover);
  color: var(--rd-text-1);
  font-weight: 500;
}

.row.on i {
  color: var(--rd-accent);
}

.row-texto {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  padding-left: 5px!important;
}

.foot {
  border-top: 1px solid var(--rd-border);
  padding-top: 10px;
  margin-top: 10px;
  position: relative;
}

.userrow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: var(--rd-radius-sm);
  cursor: pointer;
}

.userrow:hover {
  background: var(--rd-hover);
}

.avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--rd-text-2);
}

.userrow .g {
  flex: 1;
  min-width: 0;
}

.userrow .g span {
  display: block;
  font-size: 12px;
  color: var(--rd-text-1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userrow .g small {
  color: var(--rd-text-3);
  font-size: 10px;
}

.userrow > i {
  color: var(--rd-text-3);
}

.foot-menu {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border-strong);
  border-radius: var(--rd-radius-sm);
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.foot-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  color: var(--rd-text-2);
  font-size: 12.5px;
  cursor: pointer;
}

.foot-menu-item:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}
</style>
